import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AdminService } from "../services/admin-service";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";

export function RLEntityHierarchyCSVExport() {
    var directive: ng.IDirective = {
        template: `<a class="btn btn-link btn-info" ng-click="rheMV.Click($event)" rl-busy-button="" title="Export"><i class="fa fa-download"></i></a>`,
        bindToController: true,
        controllerAs: "rheMV",
        controller: RLEntityHierarchyCSVExportController,
        scope: {
            entityID: "=entityId",
            columns: "=?"
        }
    };
    return directive;
}

class RLEntityHierarchyCSVExportController {
    static $inject = ["$scope", "$timeout", "$interval", "$window", "adminService", "notifyService", "entityService"];

    entityID: string;
    columns: Models.ICustomUserColumns;
    downloadUrl: string;
    jobID: string;
    jobTitle: string;
    showJobProgressStatus: boolean;
    progressIntervalPromise: ng.IPromise<any>;

    constructor(private $scope: ng.IScope, private $timeout: ng.ITimeoutService, private $interval: ng.IIntervalService, private $window: ng.IWindowService, private adminService: AdminService, private notifyService: NotifyService, private entityService: EntityService) {
        this.jobTitle = "Export";
        this.showJobProgressStatus = false;
    }

    Click($event: ng.IAngularEvent) {
        this.notifyService.startProgress();

        var solrColumnNames: Models.IKeyValuePair<string, number>[] = [];

        var sortedColumns = _.sortBy(this.columns.columns, (col) => { return col.sequenceNumber; });

        sortedColumns.forEach(c => {
            solrColumnNames.push({ key: c.solrLabel, value: c.characteristicID });
        });

        this.entityService.exportAssociationHierarchyToCSV(this.entityID, solrColumnNames)
            .then((results) => {
                //this.downloadUrl = "";//results.data;
                this.jobID = results.jobID;
                this.showJobProgressStatus = true;
                this.StartProgress();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    StartProgress() {
        this.notifyService.startProgress();
        this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
    }

    UpdateProgress() {
        this.adminService.getJobState(this.jobID).then((result) => {
            if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
                this.$interval.cancel(this.progressIntervalPromise);
                if (result.status == "Done") {
                    this.$window.location.assign(result.resultMessage);
                }
                this.notifyService.endProgress();
            }
        });
    }
}
